import { render, staticRenderFns } from "./_ProductClickableCol.vue?vue&type=template&id=73979db1"
import script from "./_ProductClickableCol.vue?vue&type=script&lang=js"
export * from "./_ProductClickableCol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports